exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge-danger {\r\n    color: #fff;\r\n    background-color: #dc3545;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/regiones/regiones.component.css
// module id = ../../../../../src/app/components/regiones/regiones.component.css
// module chunks = main